import React, { useState } from 'react';
import './Website.css';
import { Helmet } from 'react-helmet';
import Footer from './Footer';
import DjPanel from './Djpanel';
import ContactForm from './ContactForm';
import djfracking from './assetts/DJ4.png';
import jfkBackground from './assetts/jfk-files-background-card.png';
import bunkerScan from './assetts/bunkerscan.png';
import shopTshirt from './assetts/shop-tshirt.webp';
import shopApron from './assetts/shop-apron.webp';
import shopMug from './assetts/shop-mug.webp';
import Header from './Header';
import { db } from '../../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

const shopItems = [
    {
        title: 'DJ Fracking Shirt',
        description: 'Official DJ Fracking tee, printed and shipped through Printful.',
        href: 'https://djfracking.printful.me/product/unisex-t-shirt',
        cta: 'Buy shirt',
        accentClass: 'shirt-card',
        image: shopTshirt,
    },
    {
        title: 'Kitchen Apron',
        description: 'A clean work apron for studio nights, cooking projects, and controlled chaos.',
        href: 'https://djfracking.printful.me/product/embroidered-apron',
        cta: 'Buy apron',
        accentClass: 'apron-card',
        image: shopApron,
    },
    {
        title: 'DJ Fracking Mug',
        description: 'A sturdy mug for coffee, tea, and late-night research fuel.',
        href: 'https://djfracking.printful.me/product/mug-with-color-inside',
        cta: 'Buy mug',
        accentClass: 'mug-card',
        image: shopMug,
    },
];

const LandingPage = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleMailingListSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            setMessage('Please enter a valid email address.');
            return;
        }

        if (!db) {
            setMessage('Mailing list is temporarily unavailable. Please try again soon.');
            return;
        }

        setLoading(true);
        try {
            await addDoc(collection(db, 'mailingList'), {
                email: email,
                timestamp: serverTimestamp(),
            });
            setMessage('Thanks for signing up!');
            setEmail('');
        } catch (error) {
            setMessage('There was an error signing you up. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="landing-page">
            <Helmet>
                <title>DJFracking</title>
                <meta name="description" content="DJ Fracking's official website: DJ sets, research projects, and official merch." />
                <meta name="keywords" content="DJFracking, DJ, JFK Files Archive, Underground Maps, research, merch" />
                <meta property="og:title" content="DJFracking" />
                <meta property="og:description" content="DJ sets, research projects, and official merch." />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            </Helmet>
            <Header />
            <div className="main-content">
                <main>
                    <div className="block">
                        <DjPanel />
                    </div>

                    <section className="music-section">
                        <h2>DJFracking's Favorite Songs</h2>
                        <div className="underline"></div>
                        <div className="spotify-playlist">
                            <iframe
                                style={{ borderRadius: '12px' }}
                                src="https://open.spotify.com/embed/playlist/0ioBuRyZIsCAXCR2jmOuDo?utm_source=generator&theme=0"
                                width="100%"
                                height="452"
                                frameBorder="0"
                                allowFullScreen=""
                                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                                loading="lazy"
                                title="Spotify Playlist"
                            ></iframe>
                        </div>
                    </section>

                    <section className="research-section" id="research">
                        <h2>Research</h2>
                        <div className="underline"></div>
                        <div className="research-card-grid">
                            <div className="feature-section-card media-card">
                                <img className="feature-image jfk-card-image" src={jfkBackground} alt="JFK Files Archive homepage mosaic" />
                                <div className="feature-card-body">
                                    <span>Archive</span>
                                    <h3>JFK Files Archive</h3>
                                    <p>
                                        Search 80,000+ JFK assassination records with OCR, annotations, comments, and AI-assisted discovery.
                                    </p>
                                    <div className="feature-links">
                                        <a href="https://jfkfiklesarchive.web.app" target="_blank" rel="noreferrer">Open JFK Files Archive</a>
                                        <a href="https://github.com/djfracking/jfkfilesarchive" target="_blank" rel="noreferrer">GitHub</a>
                                    </div>
                                </div>
                            </div>

                            <div className="feature-section-card media-card lab-card">
                                <div className="underground-card-image">
                                    <img src={bunkerScan} alt="Underground Maps three-dimensional structural scan" />
                                    <span aria-hidden="true">3D / FIELD SCAN</span>
                                </div>
                                <div className="feature-card-body">
                                    <span>Mapping</span>
                                    <h3>Underground Maps</h3>
                                    <p>
                                        A location-neutral workspace for layered references, structural models, and clean research exports.
                                    </p>
                                    <div className="feature-links">
                                        <a href="https://djfracking-undergroundmaps.web.app" target="_blank" rel="noreferrer">Open Underground Maps</a>
                                        <a href="https://github.com/djfracking/UndergroundMaps" target="_blank" rel="noreferrer">GitHub</a>
                                    </div>
                                </div>
                            </div>

                            <div className="feature-section-card station-feature-card">
                                <div className="feature-card-body">
                                    <span>Fracking Labs</span>
                                    <h3>Weather Satellite Station</h3>
                                    <p>
                                        Automated Meteor reception, pass timing, and decoded satellite imagery from an independent field station.
                                    </p>
                                    <div className="feature-links">
                                        <a href="/station">Open Station</a>
                                        <a href="https://github.com/djfracking" target="_blank" rel="noreferrer">Research GitHub</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="shop-preview-section" id="shop">
                        <span className="shop-kicker">Official Merch</span>
                        <h2>Shop</h2>
                        <div className="underline"></div>
                        <p className="shop-intro">
                            DJ Fracking merch is live through Printful. Shirts, aprons, and mugs ship directly from the store.
                        </p>

                        <div className="shop-card-grid">
                            {shopItems.map((item) => (
                                <article className="shop-card" key={item.title}>
                                    <div className={`shop-card-media ${item.accentClass}`}>
                                        <img src={item.image} alt={`${item.title} thumbnail`} />
                                    </div>
                                    <div className="shop-card-body">
                                        <span className="shop-pill">Printful</span>
                                        <h3>{item.title}</h3>
                                        <p>{item.description}</p>
                                        <a className="shop-button" href={item.href} target="_blank" rel="noreferrer">
                                            {item.cta}
                                        </a>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </section>

                    <section className="services-section">
                        <h2>Services</h2>
                        <div className="underline"></div>
                        <ul className="services-list">
                            <li className="service-item"><span>DJ</span></li>
                            <li className="service-item"><span>Public Speaking</span></li>
                            <li className="service-item"><span>Verizon Certified Internet Installation</span></li>
                            <li className="service-item"><span>Hot-tub Mechanic</span></li>
                            <li className="service-item"><span>Event Management</span></li>
                            <li className="service-item"><span>Nuclear Disaster Relief</span></li>
                        </ul>
                    </section>

                    <section className="about-section">
                        <div className="left-div">
                            <div className="about-image">
                                <img src={djfracking} alt="DJFracking" />
                            </div>
                        </div>
                        <div className="right-div">
                            <div className="about-content">
                                <h3>About DJ Fracking</h3>
                                <p>
                                    DJ Fracking is an enigmatic figure, whose true identity remains hidden behind the sonic landscapes he creates. Beyond his musical persona, DJ Fracking is a true renaissance man. His polymathic prowess spans an astonishing array of fields: he is an engineer, a scientist, a mathematician, a philanthropist, a motorcycle enthusiast, a chef, a romantic, a painter, a nuclear disaster recovery specialist, a writer, a photographer, a businessman, a pilot, a hot tub mechanic, a chainsaw expert, and, of course, a DJ. He embodies the ideal of a universal person, embracing a multitude of passions with equal fervor.
                                </p>
                            </div>
                        </div>
                    </section>

                    <section className="mailing-list-section">
                        <h2>Join My Mailing List</h2>
                        <div className="underline"></div>
                        <p>Stay updated on new books, DJ sets, and independent research projects.</p>
                        <form onSubmit={handleMailingListSubmit}>
                            <input
                                type="email"
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <button type="submit" disabled={loading}>
                                {loading ? 'Signing Up...' : 'Sign Up'}
                            </button>
                        </form>
                        {message && <p>{message}</p>}
                    </section>

                    <section>
                        <h2>Contact Me</h2>
                        <div className="underline"></div>
                        <ContactForm />
                    </section>
                </main>
            </div>

            <Footer />
        </div>
    );
};

export default LandingPage;
